import {useEffect, useState} from 'react';

const toVariant = (value, defaultVariant) => {
  if (value === undefined || value === null) return defaultVariant;
  if (typeof value === 'boolean') return value ? 'test' : 'control';
  return value;
};

const usePostHogFeatureFlag = (flagKey, defaultVariant = 'control') => {
  const [variant, setVariant] = useState(defaultVariant);

  useEffect(() => {
    if (!window?.posthog || !flagKey) return undefined;

    const read = () =>
      setVariant(
        toVariant(window.posthog.getFeatureFlag?.(flagKey), defaultVariant)
      );

    read();
    const unsubscribe = window.posthog.onFeatureFlags?.(read);

    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, [flagKey, defaultVariant]);

  return variant;
};

export default usePostHogFeatureFlag;
